import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { getValue } from "@utils/lodash";
import { IconHelper } from "@common/icons-helper";
import { useNavigation } from "@context/navigation-provider";
import { useAppSelector } from "@store/hooks";
import { allNavigationMenu } from "./navigation-menus";

function SideMenuItems(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const role = useAppSelector((state) => state.auth.user?.role || "user");
  const token = useAppSelector((state) => state.auth.token);

  const { clientNavigation, setClientNavigation } = useNavigation();

  useEffect(() => {
    const superAdmin = role === "admin" || role === "superadmin";
    const filteredNavigation = allNavigationMenu.filter((item: any) => {
      if (item.adminOnly) return superAdmin;
      if (item.storeOnly) return role === "store" || superAdmin;
      if (item.authOnly) return Boolean(token);
      return true;
    });

    setClientNavigation(
      filteredNavigation.map((item: any) => ({
        ...item,
        icon: IconHelper(getValue(item, "name", "")),
      }))
    );
  }, [role, token]);

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleClickMenu = (e: any) => {
    let findCurrentTab: any;
    findCurrentTab = findMenuItem(allNavigationMenu, e.key);
    if (findCurrentTab) {
      navigate(`${findCurrentTab.path}`);
    }
  };

  const findMenuItem: any = (items: any[], key: any) => {
    for (let item of items) {
      if (getValue(item, `key`, "") === key) {
        return item;
      }
      if (item.children) {
        const found = findMenuItem(item.children, key);
        if (found) {
          return found;
        }
      }
    }
  };

  const selectedKey = () => {
    const path = location.pathname;
    let best: any = null;
    const walk = (items: any[]) => {
      items.forEach((item) => {
        const matches = item.path === "/" ? path === "/" : path === item.path || path.startsWith(`${item.path}/`);
        if (matches && (!best || item.path.length > best.path.length)) {
          best = item;
        }
        if (item.children) walk(item.children);
      });
    };
    walk(allNavigationMenu);
    return [best?.key || "shop"];
  };

  const findOpenKeys = (items: any, path: any) => {
    const basePath = path.split("/")[1];
    let openKeys: string[] = [];
    for (let item of items) {
      const itemBasePath = item.path.split("/")[1];
      if (basePath === itemBasePath || path.startsWith(item.path)) {
        openKeys.push(item.key);
      }
      if (item.children) {
        const childKeys = findOpenKeys(item.children, path);
        if (childKeys.length > 0) {
          openKeys.push(item.key, ...childKeys);
        }
      }
    }
    return openKeys;
  };

  const [openKeys, setOpenKeys] = useState<string[]>(() => {
    const initialOpenKeys = findOpenKeys(allNavigationMenu, location.pathname);
    return initialOpenKeys;
  });

  return (
    <Menu
      className="store-menu"
      theme="light"
      mode="inline"
      selectedKeys={selectedKey()}
      onClick={handleClickMenu}
      items={clientNavigation}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
    />
  );
}

export default SideMenuItems;
